import { getFirestore, doc, setDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; 
import { app } from './utils/firebase'; // Your firebase config export

const db = getFirestore(app);
const auth = getAuth(app);

export const saveTokenToFirestore = async (token) => {
  const user = auth.currentUser;

  if (!user) {
    console.warn("No user logged in, cannot save token.");
    return;
  }

  // Reference the specific user's document
  const userRef = doc(db, "tokens", user.uid);

  try {
    // setDoc with { merge: true } updates the field if the doc exists, 
    // or creates the doc if it doesn't, without deleting other fields (like email/name).
    await setDoc(userRef, {
      fcmToken: token  // Stores as a single string, replacing any previous token
    }, { merge: true });

    console.log("Token updated successfully for user:", user.uid);
  } catch (error) {
    console.error("Error updating token in Firestore:", error);
  }
};